import { Component, inject } from '@angular/core';
import { LocationTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LocationTypeCreateDto,
  LocationTypeDto,
  LocationTypeExcelDownloadDto,
  LocationTypeUpdateDto,
} from '../proxy/planning/dtos/location-type';
import { LOCATIONTYPE_CONFIG, LOCATIONTYPE_FIELDS } from './location-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-location-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LocationTypeService, ConfirmationService],
  templateUrl: './location-type.html',
  styleUrl: './location-type.scss',
})
export class LocationType extends BaseCrudComponent<
  LocationTypeDto,
  LocationTypeCreateDto,
  LocationTypeUpdateDto,
  LocationTypeExcelDownloadDto
> {
  service = inject(LocationTypeService);
  config = LOCATIONTYPE_CONFIG;
  fields = LOCATIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: LocationTypeDto): LocationTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isCostReceiver: data.isCostReceiver,
      isOriginDefault: data.isOriginDefault,
      isDestinationDefault: data.isDestinationDefault,
      areaTypeId: data.areaTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LocationType';
  }
}
